import { render, staticRenderFns } from "./configuration-assays-groups-modal.vue?vue&type=template&id=4dc3f936&scoped=true&"
import script from "./configuration-assays-groups-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-assays-groups-modal.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-assays-groups-modal.scss?vue&type=style&index=0&id=4dc3f936&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3f936",
  null
  
)

export default component.exports